// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.grid[data-v-5f53af28]{\n position:absolute;\n}\nspan.float[data-v-5f53af28] {\n  float:right;\n}\n.tbl_search td[data-v-5f53af28] {\n  padding: 4px 10px 0px 10px !important;\n}\n.desc_list ul li[data-v-5f53af28]:before {\n    content: '';\n}\n.desc_list ul li[data-v-5f53af28] {\n    padding-left: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
